import { Link } from 'react-router-dom';
import { manhwaComics } from '@/mocks/manhwa';

export default function HeroSection() {
  const featuredComics = manhwaComics.filter(m => m.featured).slice(0, 5);

  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex flex-col items-center justify-center overflow-hidden bg-background-50">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20art%20style%20background%2C%20abstract%20comic%20panel%20composition%20with%20warm%20coral%20red%20and%20cream%20gradient%20tones%2C%20soft%20watercolor%20texture%2C%20elegant%20artistic%20background%20for%20comic%20reading%20platform%2C%20minimal%20modern%20design%20with%20subtle%20halftone%20pattern%2C%20no%20characters%20just%20abstract%20texture&width=1600&height=900&seq=hero-bg-manhwa&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-background-50"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-4 md:px-6 flex flex-col items-center text-center pt-12 md:pt-16 pb-8">
        {/* Main Title */}
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-background-50 leading-tight max-w-2xl">
          发现你的下一部
          <br />
          最爱韩漫 🎨
        </h1>

        {/* 3D Comic Cover Display */}
        <div className="mt-10 md:mt-14 flex items-end justify-center gap-2 md:gap-4 perspective-[1000px]">
          {featuredComics.map((comic, index) => {
            const rotations = [-12, -6, 0, 6, 12];
            const translateY = [30, 12, 0, 12, 30];
            return (
              <Link
                key={comic.id}
                to="/category/all"
                className="block shrink-0 transition-all duration-500 hover:translate-y-[-12px] hover:scale-105"
                style={{
                  transform: `rotate(${rotations[index]}deg) translateY(${translateY[index]}px)`,
                }}
              >
                <div className="w-[80px] md:w-[130px] lg:w-[150px] rounded-lg overflow-hidden shadow-lg shadow-black/20">
                  <img
                    src={comic.coverImage}
                    alt={comic.title}
                    title={`${comic.title} - 好看的韩国漫画`}
                    className="w-full aspect-[5/7] object-cover object-top"
                    loading="eager"
                  />
                </div>
              </Link>
            );
          })}
        </div>

        {/* Description */}
        <p className="mt-8 md:mt-10 text-sm md:text-base text-background-50/90 max-w-lg leading-relaxed">
          汇聚全网优质韩国漫画资源，热门合集一站收录
          <br />
          随时随地免费畅享精彩韩漫阅读体验
        </p>

        {/* CTA Buttons */}
        <div className="mt-8 flex items-center gap-4">
          <Link
            to="/category/hot-blooded-battle"
            className="px-8 py-3 rounded-full bg-background-50 text-foreground-950 font-semibold text-sm hover:bg-background-100 transition-all duration-200 whitespace-nowrap"
          >
            开始阅读
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 rounded-full border border-background-50/40 text-background-50 font-medium text-sm hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}